import type { HoursType } from "@/storage/stores"

export function getNextDayOpening(planning: HoursType[], day: { value: number }, valueSet: HoursType | undefined | null) {
    for (let i = 1; i <= 7; i++) {
        day.value = (day.value % 7) + 1
        if (day.value > 7) day.value = 1

        valueSet = planning.find((planning) =>
            planning.days.includes(day.value.toString())
        )

        if (valueSet) break
    }

    return valueSet
}